import React from 'react';
import { connect } from 'react-redux';
import utils, { toLogout } from '@/common/utils';

import './index.less';

const defaultPhoto = '//img30.360buyimg.com/pop/jfs/t1/129806/39/2034/1227/5ee348ddE64621494/f4a1e85d856802e2.png';

function UserinfoInHeader(props) {
  const { logout: _toLogout = toLogout } = props;
  return (
    <div className="userinfo-box-wrap">
      {props.loadedInfo && props.userMap && (
        <>
          <div className="userinfo-box">
            <img
              with="24"
              height="24"
              className="user-info-photo"
              src={utils.resizeImg(props.userMap.headImg || defaultPhoto, 24)}
            />
            <div className="user-info-username">
              {props.userMap.erp}
              <a onClick={() => _toLogout()} className="btn-logout">
                退出
              </a>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default connect((state) => state.userInfo)(UserinfoInHeader);
